import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'smart-fix-solution-toggle',
  templateUrl: './smart-fix-solution-toggle.component.html',
  styleUrls: ['./smart-fix-solution-toggle.component.scss'],
  imports: [CommonModule, FormsModule],
})
export class SmartFixToggleComponent {
  modeSelected = output<string>();

  modes = ['rag', 'agent-llm', 'chat-with-docs'];
  selectedMode = '';

  onModeChange(mode: string) {
    this.modeSelected.emit(mode);
  }
}
